import {Controller} from "stimulus"
import {post} from "@rails/request.js";

// data-controller="hotel-search"
export default class extends Controller {
    /*static targets = ["destination", "dateRange", "guestsRooms", "results"]*/
    static targets = ["destination", "btnCloseDestination", "dateRange", "rooms", "results", "adultsInput", "childrenInput", "roomsInput", "petsCheckbox", "formDestination", "formRangeDate", "formRooms"]

    connect() {
        // Estado inicial
        this.roomsValid = true

        if (this.hasDestinationTarget || this.hasDateRangeTarget || this.hasRoomsTarget) {
            const destination = this.destinationTarget?.value?.trim()
            const dateRange = this.dateRangeTarget?.value?.trim()
            const rooms = this.roomsTarget?.value?.trim()

            if (destination || dateRange || rooms) {
                this.search().then(r => {})
            }
        }
    }

    // método opcional para que otros triggers forcen la validación y luego hagan search
    validateAndSearch(event) {
        // forzamos la validación del campo (útil si llamas desde un botón)
        if (this.hasRoomsTarget) {
            // disparar validate programáticamente
            this.validateRooms({ currentTarget: this.roomsTarget })
        }

        this.search(event)
    }

    async search(event = null) {
        // Si la llamada viene de un input (input->search), permitimos que se ejecute
        // sólo si roomsValid es true. Si no, prevenimos y ponemos foco.
        if (event &&!this.roomsValid) {
            if (this.hasRoomsTarget) {
                this.roomsTarget.focus()
            }
            // prevenimos la búsqueda si el valor no es válido
            return
        }

        // Si no hay evento (ej. llamada desde connect), no hacemos preventDefault
        if (event) {
            event.preventDefault();
        }

        this.resultsTarget.innerHTML = `
            <div class="text-center text-muted py-5">
                <div class="spinner-border text-primary" role="status"></div>
                <p class="mt-2">Estamos comparando ofertas de hotel para ti...</p>
            </div>
            `;

        if (this.destinationTarget.value !== "") {
            this.btnCloseDestinationTarget.classList.remove("ocultar")
        }

        post(`/admin/hotel/reservas2_search_hotel`, {
            query: {
                destination: this.destinationTarget.value,
                dateRange: this.dateRangeTarget.value
                /*,
                guests: this.guestsRoomsTarget.value*/
            },
            responseKind: "turbo-stream"
        }).then(r => {
            this.isLogin(r);
            const event = new CustomEvent('search:completed');
            window.dispatchEvent(event);
        });
    }

    // Durante la escritura: sólo dejamos dígitos (no forzamos min/max)
    sanitizeRooms(event) {
        const input = event.currentTarget
        const rawValue = input.value
        const lastValid = input.getAttribute("data-last-valid") || "1"

        // Si el usuario borró con Backspace/Del dejamos que borre (permitimos vacío)
        if (event.inputType && event.inputType.startsWith("delete")) {
            // permitir borrar: marcamos inválido hasta validar en blur
            input.setAttribute("data-last-valid", "")
            this.roomsValid = false
            return
        }

        // Si event.data existe (tecla simple), usamos ese carácter
        const typed = event.data

        // Caso 1: el usuario tipeó un único carácter válido 1-6 -> lo aceptamos y lo dejamos como valor
        if (typed && /^[1-6]$/.test(typed)) {
            input.value = typed
            input.setAttribute("data-last-valid", typed)
            this.roomsValid = true
            return
        }

        // Caso 2: si no hay event.data (p. ej. pega), intentamos extraer el último carácter válido del nuevo value
        // Buscamos en rawValue el primer o último dígito 1-6; preferimos el último digit válido para UX coherente
        const match = rawValue.match(/[1-6]/g)
        if (match && match.length > 0) {
            const lastDigit = match[match.length - 1]
            input.value = lastDigit
            input.setAttribute("data-last-valid", lastDigit)
            this.roomsValid = true
            return
        }

        // Si llegamos aquí, lo escrito no contiene dígitos 1-6: revertimos al último válido
        input.value = lastValid
        this.roomsValid = lastValid !== ""
        // opcional: mostrar feedback breve
    }


    // Al salir del input: validamos y corregimos al min/max si hace falta
    validateRooms(event) {
        const input = event.currentTarget
        let value = parseInt(input.value, 10)
        const min = parseInt(input.getAttribute("min") || 1, 10)
        const max = parseInt(input.getAttribute("max") || 6, 10)

        if (isNaN(value)) {
            // si quedó vacío, lo corregimos al min (o podrías dejar vacío; aquí lo normalizo)
            value = min
            this.roomsValid = false
        } else if (value < min) {
            value = min
            this.roomsValid = false
        } else if (value > max) {
            value = max
            this.roomsValid = false
        } else {
            this.roomsValid = true
        }

        input.value = value
    }

    go_to_hotel_availability(event) {
        event.preventDefault();

        const hotel = event.currentTarget.dataset.hotel;
        /*let url_resv_hotel = "/admin/hotel/reservar-hotel";*/
        let url_resv_hotel = "/pages/ver/hoteles/reservar-hotel";

        // --- Parámetros obligatorios/optativos ---
        const params = new URLSearchParams();

        if (hotel) params.append("hotel", hotel);

        if (this.destinationTarget?.value)
            params.append("destination", this.destinationTarget.value);

        if (this.dateRangeTarget?.value)
            params.append("dateRange", this.dateRangeTarget.value);

        if (this.roomsTarget?.value)
            params.append("rooms", this.roomsTarget.value);

        /*// --- Nuevos parámetros ---
        if (this.guestsData?.adults)
            /!*params.append("adults", this.guestsData.adults);*!/
            params.append("adults", this.adultsInputTarget.value);

        if (this.guestsData?.children)
            /!*params.append("children", this.guestsData.children);*!/
            params.append("children", this.childrenInputTarget.value);

        if (this.guestsData?.rooms)
            /!*params.append("rooms", this.guestsData.rooms);*!/
            params.append("rooms", this.roomsInputTarget.value);

        if (this.guestsData?.pets !== undefined)
            /!*params.append("pets", this.guestsData.pets ? 1 : 0);*!/
            params.append("pets", this.petsCheckboxTarget.checked ? 1 : 0);*/

        // --- Construir la URL final ---
        if ([...params].length > 0) {
            url_resv_hotel += `?${params.toString()}`;
        }

        // --- Redirección con Turbo ---
        Turbo.visit(url_resv_hotel);
    }


    async go_to_hotel_availability_antes(event) {
        // event.preventDefault()
        console.info('event.target.dataset.hotel')
        console.info(event.target)
        console.info(event.target.dataset)
        console.info(event.target.dataset.hotel)
        console.info(this.destinationTarget.value)
        console.info(this.dateRangeTarget.value)
        console.info(this.guestsRoomsTarget.value)

        let hotel = event.target.dataset.hotel;
        let url_resv_hotel = `/admin/hotel/reservar-hotel`;
                // ?redirect=true
        if (hotel) {
            url_resv_hotel += `?hotel=${hotel}`;
        }
        if (this.destinationTarget.value) {
            url_resv_hotel += (hotel ? `&` : `?`) + `destination=${encodeURIComponent(this.destinationTarget.value)}`;
        }
        if (this.dateRangeTarget.value) {
            url_resv_hotel += (hotel || this.destinationTarget.value ? `&` : `?`) + `dateRange=${encodeURIComponent(this.dateRangeTarget.value)}`;
        }
        if (this.guestsRoomsTarget.value) {
            url_resv_hotel += (hotel || this.destinationTarget.value || this.dateRangeTarget.value ? `&` : `?`) + `guests=${encodeURIComponent(this.guestsRoomsTarget.value)}`;
        }

        window.location.href = url_resv_hotel;
    }


    async go_to_reservar_hotel(event) {
        event.preventDefault();

        let url_search_hotel = "/pages/ver/hoteles";

        // --- Parámetros obligatorios/optativos ---
        const params = new URLSearchParams();

        if (this.formDestinationTarget?.value)
            params.append("destination", this.formDestinationTarget.value);

        if (this.formRangeDateTarget?.value)
            params.append("dateRange", this.formRangeDateTarget.value);

        if (this.formRoomsTarget?.value)
            params.append("rooms", this.formRoomsTarget.value);

        // --- Construir la URL final ---
        if ([...params].length > 0) {
            url_search_hotel += `?${params.toString()}`;
        }

        // --- Redirección con Turbo ---
        Turbo.visit(url_search_hotel);
    }

    removeDestination(e) {
        let value = this.destinationTarget.value;
        this.destinationTarget.value = "";

        if (value !== "") {
            this.search(e).then(r => {})
            this.btnCloseDestinationTarget.classList.add("ocultar")
        }
    }

    isLogin(r) {
        if (r.responseText && typeof r.responseText.then === 'function') {
            r.responseText.then((v) => {
                let value = v.trim();

                if (value.includes("login")) {
                    window.location.href = v.trim();
                }
            })
        }
        if (r.response && typeof r.response.then === 'function') {
            r.response.then((v) => {
                let value = v.trim();

                if (value.includes("login")) {
                    window.location.href = v.trim();
                }
            })
        } else {
            if (r.response.url.includes("login")) {
                window.location.href = r.response.url;
            }
        }
    }
}
